import React, { useState, useEffect, useCallback, useRef } from 'react';
import { createPortal } from 'react-dom'; // 🛡️ [AL-BARON_FIX]: تم استدعاء البورتال الملكي لتغليف الشاشة بالكامل
import IosCard from '../../components/iOSCard';
import { 
    AcademicCapIcon, PlayCircleIcon, SparklesIcon, BellIcon, 
    CheckBadgeIcon, CalendarDaysIcon, CalendarIcon, LockClosedIcon, 
    ArrowRightOnRectangleIcon, CodeBracketIcon,
    MegaphoneIcon, ClockIcon, CheckCircleIcon,
    Bars3BottomRightIcon, XMarkIcon, UserCircleIcon, ShieldCheckIcon,
    ArrowUpTrayIcon, EllipsisVerticalIcon, ShareIcon, ComputerDesktopIcon
} from '@heroicons/react/24/outline';
import { motion, AnimatePresence } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { auth, db } from '../../firebase'; 
import { 
    doc, collection, onSnapshot, query, where, 
    getDocs, serverTimestamp, runTransaction, updateDoc
} from 'firebase/firestore';
import { signOut, onAuthStateChanged } from 'firebase/auth';

// ⬇️ [SECTION: GLASS_ALERT_COMPONENT] - مكون التنبيه الزجاجي الملكي (تم رفعه للأعلى ليناسب مستوى نافذة التفعيل)
const GlassAlert = ({ message, type, onClose }) => (
    <motion.div
        initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
        className="fixed inset-0 z-[9999999] flex items-start justify-center p-4 pt-28 backdrop-blur-md bg-black/40 font-cairo"
    >
        <motion.div
            initial={{ opacity: 0, scale: 0.9, y: -20 }} animate={{ opacity: 1, scale: 1, y: 0 }} exit={{ opacity: 0, scale: 0.9, y: -20 }}
            className="ios-glass border border-white/30 p-8 rounded-[32px] shadow-2xl flex flex-col items-center gap-5 max-w-sm w-full bg-white/95 dark:bg-[#1C1C1E]/90 backdrop-blur-3xl text-center"
        >
            <div className={`w-16 h-16 rounded-2xl flex items-center justify-center ${type === 'success' ? 'bg-green-100 dark:bg-green-500/20 text-green-600' : 'bg-red-100 dark:bg-red-500/20 text-red-600'}`}>
                {type === 'success' ? <CheckCircleIcon className="w-10 h-10" /> : <XMarkIcon className="w-10 h-10" />}
            </div>
            <div>
                <h3 className="text-xl font-black text-gray-900 dark:text-white font-cairo not-italic">{type === 'success' ? 'تمت العملية بنجاح' : 'حدث خطأ ما'}</h3>
                <p className="text-sm font-black opacity-90 mt-2 text-slate-900 dark:text-gray-300 leading-relaxed font-cairo not-italic">{message}</p>
            </div>
            <button onClick={onClose} className="w-full py-4 bg-[#007AFF] text-white rounded-2xl font-black shadow-lg active:scale-95 transition-transform font-cairo">حسناً</button>
        </motion.div>
    </motion.div>
);

const StudentDashboard = () => {
    const navigate = useNavigate();
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [activationCode, setActivationCode] = useState("");
    const [isActivated, setIsActivated] = useState(false);
    const [loading, setLoading] = useState(true);
    const [isActivating, setIsActivating] = useState(false);
    const [alertConfig, setAlertConfig] = useState({ show: false, msg: '', type: 'success' });
    const [showWelcome, setShowWelcome] = useState(false); 
    const [realStats, setRealStats] = useState({ 
        progress: 0, studyTime: 0, quizScore: "0/0", rank: "#--", activeCourse: "", name: "بطلنا" 
    });
    const [realNotifications, setRealNotifications] = useState([]);

    // 📱 [STATE: PWA_GUIDE]: حالات التحكم بدليل التنصيب الذكي والتموضع
    const [showPwaGuide, setShowPwaGuide] = useState(false);
    const [deviceType, setDeviceType] = useState('windows'); // ['ios', 'android', 'windows']
    const guideShownRef = useRef(false); // 🛡️ [ANTI-REPEAT]: منع تكرار ظهور الرسالة بفضل المرجعية البرمجية

       // 🌐 [ONLINE_STATUS_SYNC]: نظام النبضات الباروني - التعديل الجديد
    useEffect(() => {
        if (!auth.currentUser) return;
        const userRef = doc(db, "users", auth.currentUser.uid);
        
        const setOnline = async () => {
            await updateDoc(userRef, { active: true, lastActive: serverTimestamp() });
        };
        const setOffline = async () => {
            await updateDoc(userRef, { active: false, lastActive: serverTimestamp() });
        };

        setOnline();
        window.addEventListener("beforeunload", setOffline);
        return () => {
            setOffline();
            window.removeEventListener("beforeunload", setOffline);
        };
    }, [auth.currentUser]);
         
// 🛡️ [FOCUS_MONITOR]: كشف غش أو تشتت الطالب (أضفه هنا يا ضلع)
    useEffect(() => {
        if (!auth.currentUser) return;
        const userRef = doc(db, "users", auth.currentUser.uid);
        
        const handleBlur = async () => { await updateDoc(userRef, { isFocused: false }); };
        const handleFocus = async () => { await updateDoc(userRef, { isFocused: true }); };

        window.addEventListener("blur", handleBlur);
        window.addEventListener("focus", handleFocus);

        return () => {
            window.removeEventListener("blur", handleBlur);
            window.removeEventListener("focus", handleFocus);
        };
    }, [auth.currentUser]);

    // 🛡️ [AL-BARON_SECURITY_LOCK]
    // 🛡️ [AL-BARON_SECURITY_LOCK]: نظام حماية المنصة من "نقرة الماوس اليمنى" واختصارات "الكونسول" والنسخ
    useEffect(() => {
        const preventSecurityBreach = (e) => {
            if (e.type === "contextmenu") { e.preventDefault(); return false; }
            if (e.keyCode === 123 || (e.ctrlKey && e.shiftKey && (e.keyCode === 73 || e.keyCode === 74 || e.keyCode === 67)) || (e.ctrlKey && e.keyCode === 85)) {
                e.preventDefault(); return false;
            }
        };
        document.addEventListener("contextmenu", preventSecurityBreach);
        document.addEventListener("keydown", preventSecurityBreach);
        return () => {
            document.removeEventListener("contextmenu", preventSecurityBreach);
            document.removeEventListener("keydown", preventSecurityBreach);
        };
    }, []);

   // 🕵️‍♂️ [SYSTEM_DETECTOR]: فحص نوع الجهاز وتفعيل دليل التنصيب الملكي لعام 2026
    useEffect(() => {
        // ننتظر حتى ينتهي التحميل وتتأكد حالة التفعيل
        if (loading) return; 

        const ua = navigator.userAgent.toLowerCase();
        const platform = navigator.platform.toLowerCase();
        
        // تحديد نوع الجهاز بدقة
        if (/iphone|ipad|ipod/.test(ua)) {
            setDeviceType('ios');
        } 
        else if (/android/.test(ua)) {
            setDeviceType('android');
        } 
        else if (platform.includes('win') || ua.includes('windows')) {
            setDeviceType('windows');
        }
        else {
            setDeviceType('windows');
        }

        const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
        
        // [BARON_FIX]: التحقق من sessionStorage لمنع الظهور عند التنقل بين البطاقات
        const hasSeenGuide = sessionStorage.getItem('pwaGuideShown_Session');

        // 🛡️ شرط الحماية: تظهر الرسالة إذا لم يكن التطبيق مثبتاً، وإذا كان المستخدم مفعلاً، ولم تظهر مسبقاً في هذه الجلسة
        if (!isStandalone && isActivated && !guideShownRef.current && !hasSeenGuide) {
            // قفل الأمان: نفعله فوراً لمنع أي تداخل برمجياً
            guideShownRef.current = true; 

            const timer = setTimeout(() => {
                setShowPwaGuide(true);
            }, 6000); 

            return () => clearTimeout(timer);
        }
    }, [isActivated, loading]);

    // [خارطة النجاح]: البيانات الدراسية الأصلية
    const dailySuccessPlan = [
        { id: 1, task: "مشاهدة محاضرة جديدة الآن", icon: <PlayCircleIcon className="text-blue-500" /> },
        { id: 2, task: "اختبر نفسك في أسئلة الفصل", icon: <AcademicCapIcon className="text-purple-500" /> }
    ];

    // 🔄 [AUTH_SYNC]: مزامنة بيانات المستخدم والاشعارات فورياً من Firestore
    useEffect(() => {
        const unsubscribeAuth = onAuthStateChanged(auth, (user) => {
            if (user) {
                const unsubStats = onSnapshot(doc(db, "users", user.uid), (docSnap) => {
                    if (docSnap.exists()) {
                        const data = docSnap.data();
                        
                        // 🛠️ [BARON_FIX]: تم إزالة data.active من هذا الشرط حتى لا يفتح التغبيش بمجرد دخول الطالب أونلاين
                        const activeStatus = !!(data.isActivated || data.isSubscribed || data.activeCourse);
                        
                        setIsActivated(activeStatus);
                        setRealStats({
                            progress: data.overallProgress || 0, studyTime: data.totalStudyMinutes || 0,
                            quizScore: data.lastQuizScore || "0/0", rank: data.platformRank || "#--",
                            activeCourse: data.activeCourse || data.subscriptionType || "بانتظار التفعيل",
                            name: data.name?.split(' ')[0] || "بطلنا"
                        });
                        if (!sessionStorage.getItem('welcomeShown')) {
                            setShowWelcome(true); sessionStorage.setItem('welcomeShown', 'true');
                        }
                    }
                    setLoading(false);
                });
                const unsubNotify = onSnapshot(query(collection(db, "notifications")), (snapshot) => {
                    const list = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
                    setRealNotifications(list.filter(n => (n.type === 'all' || n.recipientId === user.uid) && n.type !== 'chat').sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0)));
                });
                return () => { unsubStats(); unsubNotify(); };
            } else {
                navigate('/login', { replace: true }); setLoading(false);
            }
        });
        return () => unsubscribeAuth();
    }, [navigate]);

    // 🎟️ [ACTIVATION_LOGIC]: معالجة أكواد التفعيل بنظام الـ Transaction الآمن والدمج الذكي
    const handleActivate = async () => {
        const cleanInput = activationCode.replace(/[-\s]/g, '').trim().toUpperCase();
        if (!cleanInput) { setAlertConfig({ show: true, msg: "يرجى إدخال الكود أولاً ⚠️", type: "error" }); return; }
        setIsActivating(true);
        try {
            const tokensRef = collection(db, "tokens");
            const querySnapshot = await getDocs(tokensRef);
            const tokenDocFound = querySnapshot.docs.find(doc => doc.data().code.replace(/[-\s]/g, '').toUpperCase() === cleanInput);
            if (!tokenDocFound) {
                setAlertConfig({ show: true, msg: "الكود غير موجود في النظام ❌", type: "error" });
                setIsActivating(false); return;
            }
            const tokenDataFound = tokenDocFound.data();
            if (tokenDataFound.status !== "available") {
                setAlertConfig({ show: true, msg: "هذا الكود مستخدم مسبقاً ❌", type: "error" });
                setIsActivating(false); return;
            }
            const durationType = tokenDataFound.duration;
            // 🛡️ [AL-BARON_FIX]: تنظيف الهمزات لضمان التعرف على "كورس اول"
            const cleanDuration = durationType.replace(/[أإآ]/g, "ا").toLowerCase();

            await runTransaction(db, async (transaction) => {
                const userRef = doc(db, "users", auth.currentUser.uid);
                const tokenRef = doc(db, "tokens", tokenDocFound.id);
                
                // نقرأ حالة المستخدم الحالية بالفايربيس حتى ما نمسح كورسه القديم
                const userSnap = await transaction.get(userRef);
                const currentUserData = userSnap.exists() ? userSnap.data() : {};

                let userUpdates = {
                    isActivated: true, isSubscribed: true, active: true, activatedAt: serverTimestamp(),
                    usedToken: tokenDataFound.code 
                };

                let isC1 = currentUserData.isCourse1Active === true;
                let isC2 = currentUserData.isCourse2Active === true;

                if (cleanDuration.includes("اول") || cleanDuration.includes("1")) isC1 = true;
                else if (cleanDuration.includes("ثاني") || cleanDuration.includes("2")) isC2 = true;
                else if (cleanDuration.includes("كورسين") || cleanDuration.includes("كامل")) {
                    isC1 = true; isC2 = true;
                }

                userUpdates.isCourse1Active = isC1;
                userUpdates.isCourse2Active = isC2;

                // 🛡️ [AL-BARON_FIX]: دمج الصلاحيات وتحديث حقل activeCourse جذرياً
                if (isC1 && isC2) {
                    userUpdates.activeCourse = "المنهج كامل";
                    userUpdates.subscriptionType = "المنهج كامل";
                } else {
                    userUpdates.activeCourse = durationType;
                    userUpdates.subscriptionType = durationType;
                }

                transaction.update(userRef, userUpdates);
                transaction.update(tokenRef, { status: "used", usedBy: auth.currentUser.uid, usedAt: serverTimestamp() });
            });
            setIsActivated(true); setAlertConfig({ show: true, msg: `تم تفعيل ${durationType} بنجاح! 🚀`, type: "success" }); setActivationCode(""); 
        } catch (error) { setAlertConfig({ show: true, msg: "حدث خطأ في الاتصال 🌐", type: "error" }); } 
        finally { setIsActivating(false); }
    };

    // [BARON_FUNCTION]: إغلاق الدليل وحفظ الحالة في الجلسة لمنع التكرار عند التنقل
    const handleClosePwaGuide = () => {
        setShowPwaGuide(false);
        sessionStorage.setItem('pwaGuideShown_Session', 'true');
    };

    if (loading) return <div className="min-h-screen flex items-center justify-center bg-white dark:bg-[#030303] font-cairo"><div className="w-12 h-12 border-4 border-[#007AFF] border-t-transparent rounded-full animate-spin"></div></div>;

    return (
        /* 🛡️ [FRAGMENTS_WRAPPER]: استخدمنا Fragment لرفع طبقات التغبيش فوق الـ Layout بالكامل */
        <>
            {/* 🔒 [SECTION: ACCESS_CONTROL_OVERLAY] - تم إخراجها لكسر Stacking Context وتغطية النافبار والسايدبار 100% باستخدام البورتال الملكي */}
            {!isActivated && createPortal(
                <div 
                    style={{ position: 'fixed', top: 0, right: 0, bottom: 0, left: 0 }}
                    className="z-[9999999] flex items-center justify-center p-4 backdrop-blur-3xl bg-black/80 font-cairo overflow-y-auto"
                >
                    <motion.div 
                        initial={{ opacity: 0, scale: 0.9 }} 
                        animate={{ opacity: 1, scale: 1 }} 
                        className="ios-glass p-8 sm:p-10 rounded-[40px] text-center shadow-[0_25px_60px_rgba(0,122,255,0.3)] border border-white/20 bg-white/95 dark:bg-[#1C1C1E]/95 backdrop-blur-3xl max-w-md w-full font-cairo"
                    >
                        <div className="w-20 h-20 bg-[#007AFF]/10 rounded-[30px] flex items-center justify-center mx-auto mb-6 shadow-inner border border-[#007AFF]/20 animate-pulse font-cairo">
                            <ShieldCheckIcon className="w-12 h-12 text-[#007AFF]" />
                        </div>
                        <h3 className="text-2xl sm:text-3xl font-black text-slate-900 dark:text-white font-cairo leading-snug not-italic">الدخول محمي يا بطل</h3>
                        <p className="text-xs sm:text-sm font-bold text-gray-500 dark:text-gray-400 mt-2 mb-6 font-cairo not-italic">أدخل كود التفعيل الخاص بك في الحقل أدناه لفتح المنصة والبدء فوراً 🚀</p>
                        
                        <div className="space-y-4 font-cairo">
                            <input 
                                type="text" 
                                value={activationCode} 
                                onChange={(e) => setActivationCode(e.target.value)} 
                                placeholder="XXXX-XXXX-XXX" 
                                className="w-full px-6 py-4 rounded-2xl bg-white/50 dark:bg-black/50 border border-white/20 text-center font-black text-lg text-slate-900 dark:text-white focus:outline-none focus:border-[#007AFF] shadow-inner font-cairo tracking-widest uppercase"
                            />
                            <button 
                                type="button"
                                onClick={handleActivate} 
                                disabled={isActivating}
                                className="w-full py-4 px-8 rounded-2xl bg-[#007AFF] text-white font-black text-[15px] font-cairo shadow-[0_10px_25px_rgba(0,122,255,0.4)] hover:bg-[#0056b3] transition-all active:scale-95 disabled:opacity-50"
                            >
                                {isActivating ? 'جاري التحقق والتفعيل...' : 'تفعيل الكود الآن 🚀'}
                            </button>
                        </div>
                    </motion.div>
                </div>,
                document.body
            )}

            {/* 📱 [SECTION: AL-BARON_PWA_GUIDE] - مرفوعة للطبقة العليا باستخدام البورتال الملكي */}
            {createPortal(
                <AnimatePresence>
                    {showPwaGuide && isActivated && (
                        <motion.div 
                            initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
                            className={`fixed inset-0 z-[100001] flex p-4 backdrop-blur-md bg-black/50 font-cairo ${deviceType === 'windows' ? 'items-center justify-center' : 'items-start justify-center pt-10'}`}
                        >
                            <motion.div 
                                initial={{ scale: 0.9, y: deviceType === 'windows' ? 0 : -50 }} 
                                animate={{ scale: 1, y: 0 }} exit={{ scale: 0.9, opacity: 0 }}
                                className="ios-glass p-8 rounded-[40px] bg-white/95 dark:bg-[#1C1C1E]/95 border border-[#007AFF]/30 shadow-[0_35px_80px_rgba(0,0,0,0.5)] max-w-[340px] w-full relative text-center"
                            >
                                <button onClick={handleClosePwaGuide} className="absolute top-4 right-4 text-gray-400 hover:text-red-500 active:scale-90"><XMarkIcon className="w-7 h-7" /></button>
                                
                                <div className="space-y-6">
                                    <div className="w-16 h-16 bg-[#007AFF]/10 rounded-[24px] flex items-center justify-center mx-auto text-[#007AFF] shadow-inner">
                                        {deviceType === 'windows' ? <ComputerDesktopIcon className="w-8 h-8" /> : <ArrowUpTrayIcon className="w-8 h-8" />}
                                    </div>
                                    
                                    <div>
                                        <h4 className="text-lg font-black text-gray-900 dark:text-white font-cairo">ثبت التطبيق على جهازك</h4>
                                        <p className="text-[11px] font-bold text-gray-500 dark:text-gray-400 mt-2 leading-relaxed px-2">لتحصل على أسرع تجربة دراسية VIP بدون متصفح 📱</p>
                                    </div>

                                    {/* ⬇️ محتوى الرسالة المخصص حسب نوع الجهاز ⬇️ */}
                                    <div className="bg-[#007AFF]/5 dark:bg-white/5 p-5 rounded-[30px] border border-white/10 space-y-4 text-right">
                                        
                                        {/* [SUB_SECTION: WINDOWS_INSTRUCTIONS] - تعليمات الويندوز واللابتوب */}
                                        {deviceType === 'windows' && (
                                            <div className="space-y-4">
                                                <div className="flex items-center gap-3">
                                                    <div className="w-7 h-7 bg-[#007AFF] text-white rounded-full flex items-center justify-center text-xs font-black shrink-0">1</div>
                                                    <span className="text-[11px] font-black text-gray-700 dark:text-gray-300">للوندوز | اضغط على زر الخيارات (...) في شريط العنوان العلوي و اختر More tools واختر منها Pin to taskbar </span>
                                                </div>
                                                <div className="flex items-center gap-3">
                                                    <div className="w-7 h-7 bg-[#007AFF] text-white rounded-full flex items-center justify-center text-xs font-black shrink-0">2</div>
                                                    <span className="text-[11px] font-black text-gray-700 dark:text-gray-300">للتابلت | اضغط على زر الخيارات في شريط العنوان العلوي ( ⁝ ) واختر اضافة الى الشاشة الرئيسية ثم اختر تثبيت التطبيق او Install App </span>
                                                </div>
                                            </div>
                                        )}

                                        {/* [SUB_SECTION: ANDROID_INSTRUCTIONS] - تعليمات الأندرويد */}
                                        {deviceType === 'android' && (
                                            <div className="space-y-4">
                                                <div className="flex items-center gap-3">
                                                    <div className="w-7 h-7 bg-[#007AFF] text-white rounded-full flex items-center justify-center text-xs font-black shrink-0">1</div>
                                                    <div className="flex items-center gap-2">
                                                        <span className="text-[11px] font-black text-gray-700 dark:text-gray-300">اضغط على زر الخيارات في الشريط العلوي للمتصفح ثم اختر إضافة الى الشاشة الرئيسية</span>
                                                        <div className="p-1 bg-white dark:bg-[#2C2C2E] rounded-lg shadow-sm border border-white/40 flex items-center justify-center"><EllipsisVerticalIcon className="w-5 h-5 text-[#007AFF]" /></div>
                                                    </div>
                                                </div>
                                                <div className="flex items-center gap-3">
                                                    <div className="w-7 h-7 bg-[#007AFF] text-white rounded-full flex items-center justify-center text-xs font-black shrink-0">2</div>
                                                    <span className="text-[11px] font-black text-gray-700 dark:text-gray-300">اختر "تثبيت التطبيق" أو "Install App"</span>
                                                </div>
                                            </div>
                                        )}

                                        {/* [SUB_SECTION: IOS_INSTRUCTIONS] - تعليمات الآيفون والآيباد (عربي + إنكليزي) */}
                                        {deviceType === 'ios' && (
                                            <div className="space-y-4">
                                                <div className="flex items-center gap-3">
                                                    <div className="w-7 h-7 bg-[#007AFF] text-white rounded-full flex items-center justify-center text-xs font-black shrink-0">1</div>
                                                    <div className="flex items-center gap-2">
                                                        <span className="text-[11px] font-black text-gray-700 dark:text-gray-300">إضغط على زر الخيارات في المتصفح (...) ثم اختر زر المشاركة | Tap Share</span>
                                                        <div className="p-1 bg-white dark:bg-[#2C2C2E] rounded-lg shadow-sm border border-white/40 flex items-center justify-center">
                                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#007AFF" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"/><polyline points="16 6 12 2 8 6"/><line x1="12" y1="2" x2="12" y2="15"/></svg>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="flex items-center gap-3">
                                                    <div className="w-7 h-7 bg-[#007AFF] text-white rounded-full flex items-center justify-center text-xs font-black shrink-0">2</div>
                                                    <span className="text-[11px] font-black text-gray-700 dark:text-gray-300 leading-snug">
                                                        اختر "إضافة للشاشة الرئيسية"<br/>Add to Home Screen
                                                    </span>
                                                </div>
                                            </div>
                                        )}
                                    </div>

                                    {/* زر التأكيد الملكي */}
                                    <button onClick={handleClosePwaGuide} className="w-full py-4 bg-[#007AFF] text-white rounded-2xl font-black shadow-lg active:scale-95 transition-all font-cairo text-sm">فهمت ذلك  👍</button>
                                </div>
                            </motion.div>
                        </motion.div>
                    )}
                </AnimatePresence>,
                document.body
            )}

            {/* [SECTION: WELCOME_MESSAGE] - مرفوعة للطبقة العليا بالبورتال */}
            {createPortal(
                <AnimatePresence>
                    {showWelcome && (
                        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} 
                            className={`fixed inset-0 z-[100000] flex p-6 backdrop-blur-2xl bg-black/40 font-cairo ${deviceType === 'windows' ? 'items-center justify-center' : 'items-start justify-center pt-24'}`}
                        >
                            <motion.div initial={{ scale: 0.8, y: 50 }} animate={{ scale: 1, y: 0 }} exit={{ scale: 0.8, y: 50 }} className="ios-glass p-8 rounded-[40px] bg-white/95 dark:bg-[#1C1C1E]/90 border border-white/20 shadow-2xl text-center space-y-4 max-w-sm w-full font-cairo">
                                <div className="w-16 h-16 bg-[#007AFF]/10 rounded-[25px] flex items-center justify-center mx-auto text-[#007AFF] shadow-inner font-cairo"><SparklesIcon className="w-10 h-10" /></div>
                                <div>
                                    <h2 className="text-xl font-black text-gray-900 dark:text-white font-cairo not-italic">أهلاً بك يا {realStats.name}</h2>
                                    <p className="text-xs font-bold text-gray-500 dark:text-gray-400 mt-2 not-italic">منور منصة النور.. مستعد لرحلة النجاح؟</p>
                                </div>
                                <button onClick={() => setShowWelcome(false)} className="w-full py-4 bg-[#007AFF] text-white rounded-2xl font-black shadow-xl active:scale-95 transition-all font-cairo">ابدأ الآن 🚀</button>
                            </motion.div>
                        </motion.div>
                    )}
                </AnimatePresence>,
                document.body
            )}

            {/* [SECTION: ALERTS] */}
            {createPortal(
                <AnimatePresence>
                    {alertConfig.show && <GlassAlert message={alertConfig.msg} type={alertConfig.type} onClose={() => setAlertConfig(prev => ({ ...prev, show: false }))} />}
                </AnimatePresence>,
                document.body
            )}

            {/* 🛡️ [PROTECTION]: الحاوية الرئيسية للوحة الطالب (تبقى مغبشة بالخلفية بدون التدخل بالستايل) */}
            <div style={{ fontFamily: "'Cairo', sans-serif" }} className="relative min-h-screen bg-white/10 dark:bg-[#030303] backdrop-blur-3xl text-right overflow-x-hidden w-full font-cairo select-none" dir="rtl">
                <main className="relative z-10 max-w-7xl mx-auto pt-6 sm:pt-10 px-4 font-cairo">
                    <div className={`space-y-6 transition-all duration-700 ${!isActivated ? 'blur-[12px] pointer-events-none scale-[0.98]' : 'blur-0 scale-100'}`}>
                        
                        <header className="flex justify-between items-center mb-6 ios-glass p-4 rounded-[28px] bg-white/60 dark:bg-white/5 border border-white/20 font-cairo">
                            <div className="flex items-center gap-4 text-right">
                                <div className="w-12 h-12 bg-[#007AFF] rounded-2xl flex items-center justify-center text-white shadow-lg shrink-0"><UserCircleIcon className="w-9 h-9" /></div>
                                <div className="font-cairo leading-tight">
                                    <span className="block font-black text-lg text-gray-900 dark:text-white not-italic">أهلاً بك يا {realStats.name}</span>
                                    <span className="text-[11px] font-black text-[#007AFF] uppercase not-italic opacity-90 block mt-1">الاشتراك الحالي | {realStats.activeCourse}</span>
                                </div>
                            </div>
                        </header>

                        {realNotifications.length > 0 && (
                            <div className="relative w-full overflow-hidden bg-white/40 dark:bg-white/5 backdrop-blur-2xl text-[#007AFF] py-3 rounded-2xl border border-white/20 flex items-center shadow-sm font-cairo">
                                <div className="z-10 bg-[#007AFF] h-full absolute left-0 top-0 px-3 flex items-center shadow-lg"><MegaphoneIcon className="w-5 h-5 text-white animate-pulse" /></div>
                                <div className="flex whitespace-nowrap animate-marquee">
                                    {realNotifications.concat(realNotifications).map((n, i) => (
                                        <span key={i} className="mx-12 font-black text-sm not-italic uppercase tracking-tight">{n.message || n.text}</span>
                                    ))}
                                </div>
                            </div>
                        )}

                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 font-cairo">
                            <div className="ios-glass bg-white/80 dark:bg-[#1C1C1E]/40 p-6 rounded-[35px] border border-white/30 shadow-xl font-cairo">
                                <div className="flex items-center gap-3 mb-4"><div className="p-2.5 bg-blue-500 text-white rounded-xl shadow-md"><AcademicCapIcon className="w-6 h-6" /></div><span className="font-black text-sm dark:text-white not-italic font-cairo">التقدم العام</span></div>
                                <div className="text-3xl md:text-4xl font-black mb-3 dark:text-white not-italic font-cairo">{realStats.progress}%</div>
                                <div className="w-full h-3 bg-gray-200 dark:bg-white/10 rounded-full overflow-hidden font-cairo"><motion.div initial={{ width: 0 }} animate={{ width: `${realStats.progress}%` }} className="h-full bg-gradient-to-l from-[#007AFF] to-[#5AC8FA]" /></div>
                            </div>
                            <IosCard title="وقت الدراسة" icon={<ClockIcon className="w-6 h-6 font-cairo"/>} color="purple">
                                <div className="text-3xl md:text-4xl font-black dark:text-white not-italic font-cairo">{realStats.studyTime} <span className="text-xs opacity-60 font-cairo">دقيقة</span></div>
                            </IosCard>
                            <IosCard title="آخر اختبار" icon={<CheckBadgeIcon className="w-6 h-6 font-cairo"/>} color="emerald">
                                <span className="text-3xl md:text-4xl font-black dark:text-white not-italic font-cairo">{realStats.quizScore}</span>
                            </IosCard>
                            <div className="bg-gradient-to-br from-[#FF9500] to-[#FF2D55] p-6 rounded-[35px] text-white shadow-2xl flex flex-col justify-center border border-white/20 font-cairo">
                                <div className="flex items-center gap-2 opacity-90 mb-3 font-cairo"><CalendarIcon className="w-6 h-6 font-cairo" /><span className="font-black text-sm font-cairo not-italic">ترتيب الدروس</span></div>
                                <div className="text-3xl md:text-4xl font-black font-cairo not-italic">{realStats.rank}</div>
                            </div>
                        </div>

                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 pb-4 font-cairo">
                            <div className="ios-glass bg-white/80 dark:bg-[#1C1C1E]/40 p-6 rounded-[40px] border border-white/30 shadow-xl text-right font-cairo">
                                <h3 className="text-lg md:text-xl font-black mb-6 flex items-center gap-3 text-gray-900 dark:text-white font-cairo not-italic"><CalendarDaysIcon className="w-7 h-7 text-[#007AFF]" /> خطة التفوق</h3>
                                <div className="space-y-4">
                                    {dailySuccessPlan.map((task) => (
                                        <div key={task.id} className="flex items-center justify-between p-4 bg-white/50 dark:bg-white/5 rounded-[28px] border border-white/30 shadow-sm group font-cairo">
                                            <div className="flex items-center gap-4 font-cairo">{React.cloneElement(task.icon, { className: "w-7 h-7" })}</div>
                                            <span className="font-black text-xs md:text-sm text-gray-900 dark:text-gray-100 font-cairo not-italic truncate">{task.task}</span>
                                            <CheckCircleIcon className="w-7 h-7 text-gray-300 dark:text-gray-700 shrink-0" />
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className="ios-glass bg-white/80 dark:bg-[#1C1C1E]/40 p-6 rounded-[40px] border border-white/30 shadow-xl text-right font-cairo">
                                <h3 className="text-lg md:text-xl font-black mb-6 flex items-center gap-3 text-gray-900 dark:text-white font-cairo not-italic"><BellIcon className="w-7 h-7 text-[#FF3B30]" /> التنبيهات</h3>
                                <div className="space-y-4 max-h-[300px] overflow-y-auto custom-scroll font-cairo text-right">
                                    {realNotifications.length > 0 ? realNotifications.map(n => (
                                        <div key={n.id} className="flex gap-4 p-4 bg-white/50 dark:bg-white/5 rounded-[28px] border border-white/30 shadow-sm font-cairo">
                                            <div className="w-12 h-12 bg-[#007AFF]/10 rounded-xl flex items-center justify-center shrink-0 shadow-inner font-cairo"><MegaphoneIcon className="w-6 h-6 text-[#007AFF]" /></div>
                                            <div className="flex-1 font-cairo">
                                                <p className="text-xs md:text-sm font-black leading-tight text-gray-900 dark:text-white font-cairo not-italic text-right">{n.message || n.text}</p>
                                                <span className="text-[9px] font-black mt-2 block text-[#007AFF] tracking-widest uppercase font-cairo not-italic">{n.createdAt?.seconds ? new Date(n.createdAt.seconds * 1000).toLocaleDateString('ar-EG') : 'الآن'}</span>
                                            </div>
                                        </div>
                                    )) : <div className="text-center py-6 opacity-30 font-black text-sm not-italic font-cairo">لا توجد أخبار حالياً</div>}
                                </div>
                            </div>
                        </div>

                        <footer className="pt-6 flex flex-col items-center opacity-90 pb-8 space-y-4 w-full font-cairo border-t border-white/10 mt-4">
                            <motion.a 
                                whileHover={{ scale: 1.15, rotate: 5 }} whileTap={{ scale: 0.9 }}
                                href="https://wa.me/9647739661174" target="_blank" rel="noreferrer" 
                                className="w-12 h-12 bg-[#25D366]/10 dark:bg-[#25D366]/20 rounded-2xl flex items-center justify-center text-[#25D366] shadow-lg border border-[#25D366]/20 transition-all font-cairo"
                            >
                                <svg viewBox="0 0 24 24" className="w-7 h-7 fill-current font-cairo"><path d="M12.031 6.172c-3.181 0-5.767 2.586-5.768 5.766-.001 1.298.38 2.27 1.019 3.287l-.582 2.128 2.182-.573c.978.58 1.911.928 3.145.929 3.178 0 5.767-2.587 5.768-5.766 0-3.187-2.59-5.771-5.764-5.771zm3.392 8.244c-.144.405-.837.774-1.17.824-.299.045-.677.063-1.092-.069-.252-.08-.575-.187-.988-.365-1.739-.751-2.874-2.502-2.961-2.617-.087-.116-.708-.94-.708-1.793s.448-1.273.607-1.446c.159-.173.346-.217.462-.217s.231.006.332.013c.105.007.246-.038.384.295.144.346.491 1.2.534 1.287.043.087.072.188.014.304-.058.116-.087.188-.173.289l-.26.304c-.087.086-.177.18-.076.354.101.174.449.741.964 1.201.662.591 1.221.777 1.394.864.174.088.275.073.377-.043.101-.116.434-.506.549-.68.116-.174.231-.145.39-.087s1.011.477 1.184.564.289.13.332.202c.045.072.045.419-.1.824zM12 2C6.477 2 2 6.477 2 12c0 1.885.519 3.654 1.429 5.175L2 22l5.021-1.321c1.442.822 3.111 1.3 4.979 1.3 5.523 0 10-4.477 10-10S17.523 2 12 2zm0 18c-1.734 0-3.351-.462-4.742-1.261l-.34-.195-2.98.784.797-2.91-.215-.341C3.714 14.706 3.25 13.407 3.25 12c0-4.825 3.925-8.75 8.75-8.75s8.75 3.925 8.75 8.75-3.925 8.75-8.75 8.75z" /></svg>
                            </motion.a>
                            <div className="flex flex-col items-center gap-1 font-cairo">
                                <div className="flex items-center gap-3 font-cairo">
                                    <CodeBracketIcon className="w-6 h-6 text-[#007AFF]" />
                                    <span className="text-xs md:text-sm font-black text-gray-900 dark:text-white uppercase tracking-widest not-italic">MK@AlBARON DEVELOPMENT 2026</span>
                                </div>
                                <span className="text-[9px] font-black text-gray-500 dark:text-gray-400 uppercase tracking-widest not-italic">VERSION 2.1.0 | SECURED BY AL-BARON</span>
                            </div>
                        </footer>
                    </div>

                    {!isActivated && (<div className="absolute inset-0 bg-white/5 dark:bg-black/5 z-10 rounded-[30px]" />)}
                </main>
            </div>
        </>
    );
};

export default StudentDashboard;